import PropTypes from 'prop-types';
import React from 'react'
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share';


export default class extends React.Component {
    static propTypes = {
		className: PropTypes.string
	};

    render() {

		const {
			FacebookShareButton,
			LinkedinShareButton,
			TwitterShareButton
		} = ShareButtons;

		const FacebookIcon = generateShareIcon('facebook');
		const TwitterIcon = generateShareIcon('twitter');
		const LinkedinIcon = generateShareIcon('linkedin');

		return (
			<div className={"clearfix " + (!!this.props.className ? this.props.className : '')}>

				<div className="pull-left mright10 clickable">
					<FacebookShareButton url={typeof document !== 'undefined' ? document.location.href : ''}><FacebookIcon size={35} round={true} /></FacebookShareButton>
				</div>

				<div className="pull-left mright10 clickable">
					<TwitterShareButton url={typeof document !== 'undefined' ? document.location.href : ''}><TwitterIcon size={35} round={true} /></TwitterShareButton>
				</div>

				<div className="pull-left mright10 clickable">
					<LinkedinShareButton url={typeof document !== 'undefined' ? document.location.href : ''}><LinkedinIcon size={35} round={true} /></LinkedinShareButton>
				</div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Article/components/SocialIcons.js